import React, { useEffect } from "react";
import {
  Box,
  Button,
  FormControlLabel,
  Link,
  Stack,
  Typography,
} from "@mui/material";
import AuthLogo from "assets/images/AuthLogo.svg";
import AuthBG from "assets/images/AuthBG.png";
import AuthTextField from "components/AuthTextField";
import Switch from "components/Switch";

const AuthLayout = ({ children } : {children: React.ReactNode}) => {
  return (
      <Box maxWidth={1440} mx={"auto"}>
        <Stack direction="row" justifyContent={"space-between"}>
          <Stack mx="auto" width={"100%"} px={10} maxWidth={500}>
            <Stack direction={"row"} py={10}>
              <Box component={"img"} src={AuthLogo} />
              <Typography
                variant="h1"
                component={"h1"}
                color={"primary.dark"}
                fontFamily={"Forever Freedom"}
                fontStyle={"italic"}
              >
                BABELCAST
              </Typography>
            </Stack>
            {children}
          </Stack>

          <Stack>
            <Box>
              <Box component={"img"} src={AuthBG} />
            </Box>
            <Stack direction="row" spacing={1} justifyContent={"space-around"}>
              <Link color={"primary.dark"} underline="hover">What is babelcast?</Link>
              <Link color={"text.light"} underline="hover">Product Demo</Link>
              <Link color={"text.light"} underline="hover">Features</Link>
              <Link color={"text.light"} underline="hover">How You Scale</Link>
            </Stack>
          </Stack>
        </Stack>
      </Box>
  );
};

export default AuthLayout;
